import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useActivityStore } from "@/stores/activityStore";
import { useWorkflowLandingStore } from "@/stores/workflowLandingStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
import WorkflowRun from "@/components/Workflow/Run/WorkflowRun.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowLanding',
    props: {
        uuid: null,
        secret: { default: undefined },
        public: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const store = useWorkflowLandingStore();
        const { claimWorkflow } = store;
        const { claimState } = storeToRefs(store);
        const activityStore = useActivityStore("default");
        // Start claim immediately
        claimWorkflow(props.uuid, props.public, props.secret).then(() => {
            activityStore.closeSideBar();
        });
        return { __sfc: true, props, store, claimWorkflow, claimState, activityStore, BAlert, LoadingSpan, WorkflowRun };
    }
});
